// // use colorThief to get the color palette from the image
// const ColorThief = require('colorthief');

// export function getColors(path) {

//     ColorThief.getPalette(path, 5).then(palette => { console.log(palette) })
//     .catch(err => { console.log(err) })
//     // return colorPalette;
// }

// import ColorThief from '../../../../node_modules/colorthief/dist/color-thief.mjs'

function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
export function getColors(path) {
  // set image path
  const img = new Image();
  img.src = path;

  return new Promise((resolve) => {
    img.onload = function () {
      // create a canvas element
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      // draw the image on the canvas
      const context = canvas.getContext("2d");
      // if image is too big, compress it
      const size = 1000;
      if (img.width > size || img.height > size) {
        // get the image ratio
        const ratio = img.width / img.height;
        // use the ratio to calculate the new width and height of the image so it fits in the 1000x1000 box
        canvas.width = ratio > 1 ? size : size * ratio;
        canvas.height = ratio > 1 ? size / ratio : size;
      }

      context.drawImage(img, 0, 0, canvas.width, canvas.height);
      // context.drawImage(img, 0, 0, img.width, img.height);

      // get the image data
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // log the data
      // console.log("the data is: ", data);

      // loop through the uint8ClampedArray and get the color count of each color
      const colorCount = {};

      // skip every 2rd color to speed up the process
      for (let i = 0; i < data.length; i += 8) {
        const red = data[i];
        const green = data[i + 1];
        const blue = data[i + 2];
        const alpha = data[i + 3];

        // skip transparent pixels
        if (alpha === 0) {
          continue;
        }

        // convert the color to a hex string
        const color = rgbToHex(red, green, blue);

        // if the color is in the colorCount object, increment the count
        if (color in colorCount) {
          colorCount[color]++;
        } else {
          // otherwise, set the count to 1
          colorCount[color] = 1;
        }
      }

      // group together the colors that are close to each other (within 10%) and keep track of the count
      const colorGroups = {};
      for (const color in colorCount) {
        // get the red, green, and blue values of the color
        const red = parseInt(color.substring(1, 3), 16);
        const green = parseInt(color.substring(3, 5), 16);
        const blue = parseInt(color.substring(5, 7), 16);

        // loop through the colorGroups object
        let colorGroupFound = false;
        for (const colorGroup in colorGroups) {
          // get the red, green, and blue values of the color group
          const colorGroupRed = parseInt(colorGroup.substring(1, 3), 16);
          const colorGroupGreen = parseInt(colorGroup.substring(3, 5), 16);
          const colorGroupBlue = parseInt(colorGroup.substring(5, 7), 16);

          // if the color is within 15% of the color group, add it to the color group
          if (
            Math.abs(red - colorGroupRed) <= 25 &&
            Math.abs(green - colorGroupGreen) <= 25 &&
            Math.abs(blue - colorGroupBlue) <= 25
          ) {
            colorGroups[colorGroup] += colorCount[color];
            colorGroupFound = true;
            break;
          }
        }

        // if the color is not within 10% of any color group, create a new color group
        if (!colorGroupFound) {
          colorGroups[color] = colorCount[color];
        }
      }
      // print the color groups
      // console.log("bruh: ", colorGroups);

      // sort the color groups by count
      const sortedColorGroups = Object.keys(colorGroups).sort(function (a, b) {
        return colorGroups[b] - colorGroups[a];
      });

      // log the color groups with the count
      console.log("the color groups are: ", sortedColorGroups);

      // count the total count of all elements in the color groups
      let total = 0;
      for (const color in colorGroups) {
        total += colorGroups[color];
      }

      // remove the colors that are less than 5% from sortedColorGroups
      const filteredColorGroups = sortedColorGroups.filter(function (color) {
        return colorGroups[color] / total >= 0.025;
      });

      // log the filtered color groups with the count as a percentage
      console.log(
        "the filtered color groups as a percentage are: ",
        filteredColorGroups.map(function (color) {
          return (
            color + " (" + Math.round((colorGroups[color] / total) * 100) + "%)"
          );
        })
      );

      // get the top 5 colors
      const topColors = filteredColorGroups.slice(0, 2);

      // log the top colors
      console.log("the top colors are: ", topColors);

      resolve(topColors);
      // resolve(colorPalette);
    };
  });

  // const colors = [];
  // for (let i = 0; i < data.length; i += 4) {
  //     const red = data[i];
  //     const green = data[i + 1];
  //     const blue = data[i + 2];
  //     const alpha = data[i + 3];
  //     const color = `rgba(${red}, ${green}, ${blue}, ${alpha})`;
  //     colors.push(color);
  // }
}

export async function getColorsOld(path) {
  // const colorThief = new ColorThief();
  // set image path
  const img = new Image();
  img.src = path;
  // get the color palette from the image
  return new Promise((resolve) => {
    img.onload = function () {
      // const colorPalette = colorThief.getPalette(img, 5)

      // map each rgb color in palette to a hex value
      // slice color palatte to only get the first 2 colors

      // const hexPalette = colorPalette.slice(0, 2).map(color => {
      //     return rgbToHex(color[0], color[1], color[2]);
      // })

      // console.log(hexPalette);
      resolve();
    };
  });
}
export async function newGetColors(path) {
  // set image path
  const img = new Image();
  img.src = path;
  // get the color palette from the image
  return new Promise((resolve) => {
    img.onload = function () {
      // // get the color of the pixel 0,0 by reading the raw data
      // const canvas = document.createElement('canvas');
      // canvas.width = img.width;
      // canvas.height = img.height;
      // const ctx = canvas.getContext('2d');
      // ctx.drawImage(img, 0, 0);
      // const pixels = ctx.getImageData(0, 0, img.width, img.height).data;
      // // cycle through all pixels convert the pixel data to hex with a count of all the repeated colors
      // const hexPalette = [];
      // for (let i = 0; i < pixels.length; i += 4) {
      //     const hex = rgbToHex(pixels[i], pixels[i + 1], pixels[i + 2]);
      //     //compress hex color from #123456 to #135
      //     const compressedHex = hex.replace(/(.)(.)(.)(.)(.)(.)/, '#$1$3$5');
      //     if (hexPalette[compressedHex]) {
      //         hexPalette[compressedHex]++;
      //     } else {
      //         hexPalette[compressedHex] = 1;
      //     }
      // }
      // // sort hex palette by color count
      // const sortedHexPalette = Object.keys(hexPalette).sort((a, b) => hexPalette[b] - hexPalette[a]);
      // console.log(sortedHexPalette);
      // // const color = rgbToHex(pixel[0], pixel[1], pixel[2]);
      // //     // map each rgb color in palette to a hex value
      // //     // slice color palatte to only get the first 2 colors
      // //     const hexPalette = colorPalette.slice(0,5).map(color => {
      // //         return rgbToHex(color[0], color[1], color[2]);
      // //     })
      //     // console.log(hexPalette);
      //     resolve(hexPalette);
    };
  });
}
